import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import './styles/global.css';
import reportWebVitals from './reportWebVitals';
import { ReactQueryProvider } from 'lib/react-query/provider';
import { StateProvider } from 'state/provider';
import { shouldShowFlightDemo } from 'components/FlightDemo/flight-demo.gate';

const FlightDemoApp = lazy(() => import('pages/FlightDemo/FlightDemoApp'));

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// The flight booking UI demo has no session, API or store, so it is mounted on
// its own instead of inside <App />. Disabled on live builds (see config.ts).
const showFlightDemo = shouldShowFlightDemo(window.location.pathname);

const renderBookingApp = () => {
  // Required lazily on purpose: importing App evaluates @stripe/stripe-js,
  // which injects Stripe.js into the page, and the demo must not load Stripe.
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const App = require('./App').default;

  return (
    <ReactQueryProvider>
      <StateProvider>
        <App />
      </StateProvider>
    </ReactQueryProvider>
  );
};

root.render(
  <React.StrictMode>
    {showFlightDemo ? (
      <Suspense fallback={null}>
        <FlightDemoApp />
      </Suspense>
    ) : (
      renderBookingApp()
    )}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
